import React,{useState} from 'react'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
function MerRadio(props) {
     const [value, setValue] = useState(props.info.value);
     
    return (
    <FormControl>
      <div style={{display:'flex',justifyContent:'space-between', alignItems:'center' ,marginTop:2, marginBottom:2}}>
      <FormLabel required={props.info.mandatory} 
            sx={{'& .MuiFormLabel-asterisk': {
              color: 'red', fontSize: '30px'
            },
            color:'black',
            maxWidth:'60%',
            }}>{props.info.question_text}</FormLabel>
      <RadioGroup
        row
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          props.handleChange(props.info?.id,e.target.value,props.info?._id);
      }}
        >
          {
            props.info.options.map((option,index) => {
                return(
                  <FormControlLabel key={index} sx={{color:'black'}} value={option} control={<Radio />} label={option} disabled={!props.abled}/>
                );
            })
          }
          
      </RadioGroup>
      </div>
    </FormControl>
  )
}

export default MerRadio
